"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    buttonClassNames: ()=>buttonClassNames,
    useButtonStyles_unstable: ()=>useButtonStyles_unstable
});
const _react = require("@griffel/react");
const buttonClassNames = {
    root: 'fui-Button',
    icon: 'fui-Button__icon'
};
const iconSpacingVar = '--fui-Button__icon--spacing';
const buttonSpacingSmall = '3px';
const buttonSpacingSmallWithIcon = '1px';
const buttonSpacingMedium = '5px';
const buttonSpacingLarge = '8px';
const buttonSpacingLargeWithIcon = '7px';
const useRootBaseClassName = /*#__PURE__*/ (0, _react["__resetStyles"])("rsawnvh", "r1eny37h", [
    ".rsawnvh{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;box-sizing:border-box;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;text-decoration-line:none;vertical-align:middle;margin:0;overflow:hidden;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);font-family:var(--fontFamilyBase);outline-style:none;padding:5px var(--spacingHorizontalM);min-width:96px;border-radius:var(--borderRadiusMedium);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);transition-duration:var(--durationFaster);transition-property:background,border,color;transition-timing-function:var(--curveEasyEase);}",
    ".rsawnvh:hover{background-color:var(--colorNeutralBackground1Hover);border-color:var(--colorNeutralStroke1Hover);color:var(--colorNeutralForeground1Hover);cursor:pointer;}",
    ".rsawnvh:hover .fui-Icon-filled{display:inline;}",
    ".rsawnvh:hover .fui-Icon-regular{display:none;}",
    ".rsawnvh:hover:active{background-color:var(--colorNeutralBackground1Pressed);border-color:var(--colorNeutralStroke1Pressed);color:var(--colorNeutralForeground1Pressed);outline-style:none;}",
    ".rsawnvh:hover:active .fui-Icon-filled{display:inline;}",
    ".rsawnvh:hover:active .fui-Icon-regular{display:none;}",
    "@media screen and (prefers-reduced-motion: reduce){.rsawnvh{transition-duration:0.01ms;}}",
    "@media (forced-colors: active){.rsawnvh:focus{border-color:ButtonText;}.rsawnvh:hover{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}.rsawnvh:hover:active{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}}",
    ".rsawnvh:focus{outline-style:none;}",
    ".rsawnvh:focus-visible{outline-style:none;}",
    ".rsawnvh[data-fui-focus-visible]{border-color:var(--colorTransparentStroke);border-radius:var(--borderRadiusMedium);outline:var(--strokeWidthThick) solid var(--colorTransparentStroke);box-shadow:var(--shadow4),0 0 0 2px var(--colorStrokeFocus2);z-index:1;}",
    ".r1eny37h{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;box-sizing:border-box;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;text-decoration-line:none;vertical-align:middle;margin:0;overflow:hidden;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);font-family:var(--fontFamilyBase);outline-style:none;padding:5px var(--spacingHorizontalM);min-width:96px;border-radius:var(--borderRadiusMedium);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);transition-duration:var(--durationFaster);transition-property:background,border,color;transition-timing-function:var(--curveEasyEase);}",
    ".r1eny37h:hover{background-color:var(--colorNeutralBackground1Hover);border-color:var(--colorNeutralStroke1Hover);color:var(--colorNeutralForeground1Hover);cursor:pointer;}",
    ".r1eny37h:hover .fui-Icon-filled{display:inline;}",
    ".r1eny37h:hover .fui-Icon-regular{display:none;}",
    ".r1eny37h:hover:active{background-color:var(--colorNeutralBackground1Pressed);border-color:var(--colorNeutralStroke1Pressed);color:var(--colorNeutralForeground1Pressed);outline-style:none;}",
    ".r1eny37h:hover:active .fui-Icon-filled{display:inline;}",
    ".r1eny37h:hover:active .fui-Icon-regular{display:none;}",
    "@media screen and (prefers-reduced-motion: reduce){.r1eny37h{transition-duration:0.01ms;}}",
    "@media (forced-colors: active){.r1eny37h:focus{border-color:ButtonText;}.r1eny37h:hover{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}.r1eny37h:hover:active{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}}",
    ".r1eny37h:focus{outline-style:none;}",
    ".r1eny37h:focus-visible{outline-style:none;}",
    ".r1eny37h[data-fui-focus-visible]{border-color:var(--colorTransparentStroke);border-radius:var(--borderRadiusMedium);outline:var(--strokeWidthThick) solid var(--colorTransparentStroke);box-shadow:var(--shadow4),0 0 0 2px var(--colorStrokeFocus2);z-index:1;}"
]);
const useIconBaseClassName = /*#__PURE__*/ (0, _react["__resetStyles"])("rywnvv2", null, [
    ".rywnvv2{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;font-size:20px;height:20px;width:20px;--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}"
]);
const useRootStyles = /*#__PURE__*/ (0, _react["__styles"])({
    outline: {
        De3pzq: "f1c21dwh",
        Jwef8y: "fjxutwb",
        iro3zm: "fwiml72"
    },
    primary: {
        De3pzq: "ffp7eso",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "f1phragk",
        Jwef8y: "f15wkkf3",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f1rq72xc",
        iro3zm: "fnp9lpt",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ],
        B2d53fq: "f1d6v5y2",
        Bsw6fvg: "f1rirnrt",
        Bjwas2f: "f1uu00uk",
        Bn1d65q: [
            "fkvaka8",
            "f9a0qzu"
        ],
        Bxeuatn: "f1ux7til",
        n51gp8: [
            "f9a0qzu",
            "fkvaka8"
        ],
        Bbusuzp: "f1lkg8j3",
        ycbfsm: "fkc42ay",
        Bqrx1nm: "fq7113v",
        pgvf35: "ff1wgvm",
        Bh7lczh: [
            "fiob0tu",
            "f1x4h75k"
        ],
        dpv3f4: "f1j6scgf",
        Bpnjhaq: [
            "f1x4h75k",
            "fiob0tu"
        ],
        ze5xyy: "f4xjyn1",
        g2kj27: "fbgcvur",
        Bf756sw: "f1ks1yx8",
        Bow2dr7: [
            "f1o6qegi",
            "fmxjhhp"
        ],
        Bvhedfk: "fcnxywj",
        Gye4lf: [
            "fmxjhhp",
            "f1o6qegi"
        ],
        pc6evw: "f9ddjv3"
    },
    secondary: {},
    subtle: {
        De3pzq: "fhovq9v",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "fkfq4zb",
        Jwef8y: "f1t94bn6",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "fnwyq0v",
        Bbdnnc7: "fy5bs14",
        iro3zm: "fsv2rcd",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ],
        B2d53fq: "f1omzyqd",
        x3br3k: "fj8yq94"
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        sj55zd: "fkfq4zb",
        Jwef8y: "fjxutwb",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        Bi91k9c: "f139oj5f",
        iro3zm: "fwiml72",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ],
        B2d53fq: "f1fg1p5m"
    },
    circular: {
        Bbmb7ep: [
            "f8fbkgy",
            "f1nfllo7"
        ],
        Beyfa6y: [
            "f1nfllo7",
            "f8fbkgy"
        ],
        B7oj6ja: [
            "f1djnp8u",
            "f1s8kh49"
        ],
        Btl43ni: [
            "f1s8kh49",
            "f1djnp8u"
        ]
    },
    rounded: {},
    square: {
        Bbmb7ep: [
            "fzi6hpg",
            "fyowgf4"
        ],
        Beyfa6y: [
            "fyowgf4",
            "fzi6hpg"
        ],
        B7oj6ja: [
            "f3fg2lr",
            "f13av6d4"
        ],
        Btl43ni: [
            "f13av6d4",
            "f3fg2lr"
        ]
    },
    small: {
        Bf4jedk: "fh7ncta",
        z8tnut: "f1khb0e9",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "f1jnq6q7",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        Bbmb7ep: [
            "fclariu",
            "fyjfh2l"
        ],
        Beyfa6y: [
            "fyjfh2l",
            "fclariu"
        ],
        B7oj6ja: [
            "f11xeu6h",
            "f1knf8zw"
        ],
        Btl43ni: [
            "f1knf8zw",
            "f11xeu6h"
        ],
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    },
    smallWithIcon: {
        Byoj8tv: "f1brlhvm",
        z8tnut: "f1sl3k7w"
    },
    medium: {},
    large: {
        Bf4jedk: "f14es27b",
        z8tnut: "fp9bwmr",
        z189sj: [
            "fjodcmx",
            "fhx4nu"
        ],
        Byoj8tv: "f150uoa4",
        uwmqm3: [
            "fhx4nu",
            "fjodcmx"
        ],
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    largeWithIcon: {
        Byoj8tv: "fy7v416",
        z8tnut: "f1a1bwwz"
    }
}, {
    d: [
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".ffp7eso{background-color:var(--colorBrandBackground);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}",
        ".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",
        ".fhovq9v{background-color:var(--colorSubtleBackground);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".f8fbkgy{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f1nfllo7{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".f1djnp8u{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f1s8kh49{border-top-left-radius:var(--borderRadiusCircular);}",
        ".fzi6hpg{border-bottom-right-radius:var(--borderRadiusNone);}",
        ".fyowgf4{border-bottom-left-radius:var(--borderRadiusNone);}",
        ".f3fg2lr{border-top-right-radius:var(--borderRadiusNone);}",
        ".f13av6d4{border-top-left-radius:var(--borderRadiusNone);}",
        ".fh7ncta{min-width:64px;}",
        ".f1khb0e9{padding-top:3px;}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1jnq6q7{padding-bottom:3px;}",
        ".fclariu{border-bottom-right-radius:3px;}",
        ".fyjfh2l{border-bottom-left-radius:3px;}",
        ".f11xeu6h{border-top-right-radius:3px;}",
        ".f1knf8zw{border-top-left-radius:3px;}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".f1brlhvm{padding-bottom:1px;}",
        ".f1sl3k7w{padding-top:1px;}",
        ".f14es27b{min-width:96px;}",
        ".fp9bwmr{padding-top:8px;}",
        ".fjodcmx{padding-right:var(--spacingHorizontalL);}",
        ".fhx4nu{padding-left:var(--spacingHorizontalL);}",
        ".f150uoa4{padding-bottom:8px;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".fy7v416{padding-bottom:7px;}",
        ".f1a1bwwz{padding-top:7px;}"
    ],
    h: [
        ".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",
        ".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}",
        ".f15wkkf3:hover{background-color:var(--colorBrandBackgroundHover);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".f1rq72xc:hover{color:var(--colorNeutralForegroundOnBrand);}",
        ".fnp9lpt:hover:active{background-color:var(--colorBrandBackgroundPressed);}",
        ".f1h0usnq:hover:active{border-top-color:transparent;}",
        ".fs4ktlq:hover:active{border-right-color:transparent;}",
        ".fx2bmrt:hover:active{border-left-color:transparent;}",
        ".f16h9ulv:hover:active{border-bottom-color:transparent;}",
        ".f1d6v5y2:hover:active{color:var(--colorNeutralForegroundOnBrand);}",
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",
        ".fy5bs14:hover .fui-Button__icon{color:var(--colorNeutralForeground2BrandHover);}",
        ".fsv2rcd:hover:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1omzyqd:hover:active{color:var(--colorNeutralForeground2Pressed);}",
        ".fj8yq94:hover:active .fui-Button__icon{color:var(--colorNeutralForeground2BrandPressed);}",
        ".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",
        ".f1fg1p5m:hover:active{color:var(--colorNeutralForeground2BrandPressed);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1uu00uk{border-top-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkvaka8{border-right-color:HighlightText;}.f9a0qzu{border-left-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ux7til{border-bottom-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9a0qzu{border-left-color:HighlightText;}.fkvaka8{border-right-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fq7113v:hover{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.ff1wgvm:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fiob0tu:hover{border-right-color:Highlight;}.f1x4h75k:hover{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1j6scgf:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1x4h75k:hover{border-left-color:Highlight;}.fiob0tu:hover{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f4xjyn1:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fbgcvur:hover:active{background-color:HighlightText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ks1yx8:hover:active{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1o6qegi:hover:active{border-right-color:Highlight;}.fmxjhhp:hover:active{border-left-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fcnxywj:hover:active{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fmxjhhp:hover:active{border-left-color:Highlight;}.f1o6qegi:hover:active{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9ddjv3:hover:active{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useRootDisabledStyles = /*#__PURE__*/ (0, _react["__styles"])({
    base: {
        De3pzq: "f1bg9a2p",
        g2u3we: "f1jj8ep1",
        h3c5rm: [
            "f15xbau",
            "fy0fskl"
        ],
        B9xav0g: "f4ikngz",
        zhjwy3: [
            "fy0fskl",
            "f15xbau"
        ],
        sj55zd: "f1s2aq7o",
        Bceei9c: "fdrzuqr",
        Jwef8y: "f1falr9n",
        Bgoe8wy: "f12mpcsy",
        Bwzppfd: [
            "f1gwvigk",
            "f18rmfxp"
        ],
        oetu4i: "f1jnshp0",
        gg5e9n: [
            "f18rmfxp",
            "f1gwvigk"
        ],
        Bi91k9c: "fvgxktp",
        eoavqd: "fphbwmw",
        Bk3fhr4: "f19vpps7",
        Bmfj8id: "fv5swzo",
        iro3zm: "f1t6o4dc",
        b661bw: "f10ztigi",
        Bk6r4ia: [
            "f1ft5sdu",
            "f1gzf82w"
        ],
        B9zn80p: "f12zbtn2",
        Bpld233: [
            "f1gzf82w",
            "f1ft5sdu"
        ],
        B2d53fq: "fcvwxyo",
        c3iz72: "f8w4c43",
        em6i61: "f1ol4fw6",
        vm6p8p: "f1q1lw4e"
    },
    highContrast: {
        Bsw6fvg: "f4lkoma",
        Bjwas2f: "fg455y9",
        Bn1d65q: [
            "f1rvyvqg",
            "f14g86mu"
        ],
        Bxeuatn: "f1cwzwz",
        n51gp8: [
            "f14g86mu",
            "f1rvyvqg"
        ],
        Bbusuzp: "f1dcs8yz",
        G867l3: "fjwq6ea",
        gdbnj: [
            "f1lr3nhc",
            "f1mbxvi6"
        ],
        mxns5l: "fn5gmvv",
        o3nasb: [
            "f1mbxvi6",
            "f1lr3nhc"
        ],
        Bqrx1nm: "f1vmkb5g",
        pgvf35: "f53ppgq",
        Bh7lczh: [
            "f1663y11",
            "f80fkiy"
        ],
        dpv3f4: "f18v5270",
        Bpnjhaq: [
            "f80fkiy",
            "f1663y11"
        ],
        ze5xyy: "f1kc2mi9",
        g2kj27: "f1y0svfh",
        Bf756sw: "fihuait",
        Bow2dr7: [
            "fnxhupq",
            "fyd6l6x"
        ],
        Bvhedfk: "fx507ft",
        Gye4lf: [
            "fyd6l6x",
            "fnxhupq"
        ],
        pc6evw: "fb3rf2x"
    },
    outline: {
        De3pzq: "f1c21dwh",
        Jwef8y: "f9ql6rf",
        iro3zm: "f3h1zc4"
    },
    primary: {
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ]
    },
    secondary: {},
    subtle: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "f9ql6rf",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        iro3zm: "f3h1zc4",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ]
    },
    transparent: {
        De3pzq: "f1c21dwh",
        g2u3we: "f1p3nwhy",
        h3c5rm: [
            "f11589ue",
            "f1pdflbu"
        ],
        B9xav0g: "f1q5o8ev",
        zhjwy3: [
            "f1pdflbu",
            "f11589ue"
        ],
        Jwef8y: "f9ql6rf",
        Bgoe8wy: "f1s2uweq",
        Bwzppfd: [
            "fr80ssc",
            "fecsdlb"
        ],
        oetu4i: "f1ukrpxl",
        gg5e9n: [
            "fecsdlb",
            "fr80ssc"
        ],
        iro3zm: "f3h1zc4",
        b661bw: "f1h0usnq",
        Bk6r4ia: [
            "fs4ktlq",
            "fx2bmrt"
        ],
        B9zn80p: "f16h9ulv",
        Bpld233: [
            "fx2bmrt",
            "fs4ktlq"
        ]
    }
}, {
    d: [
        ".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".f1p3nwhy{border-top-color:transparent;}",
        ".f11589ue{border-right-color:transparent;}",
        ".f1pdflbu{border-left-color:transparent;}",
        ".f1q5o8ev{border-bottom-color:transparent;}"
    ],
    h: [
        ".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".fphbwmw:hover{cursor:not-allowed;}",
        ".f19vpps7:hover .fui-Icon-filled{display:none;}",
        ".fv5swzo:hover .fui-Icon-regular{display:inline;}",
        ".f1t6o4dc:hover:active{background-color:var(--colorNeutralBackgroundDisabled);}",
        ".f10ztigi:hover:active{border-top-color:var(--colorNeutralStrokeDisabled);}",
        ".f1ft5sdu:hover:active{border-right-color:var(--colorNeutralStrokeDisabled);}",
        ".f1gzf82w:hover:active{border-left-color:var(--colorNeutralStrokeDisabled);}",
        ".f12zbtn2:hover:active{border-bottom-color:var(--colorNeutralStrokeDisabled);}",
        ".fcvwxyo:hover:active{color:var(--colorNeutralForegroundDisabled);}",
        ".f8w4c43:hover:active{cursor:not-allowed;}",
        ".f1ol4fw6:hover:active .fui-Icon-filled{display:none;}",
        ".f1q1lw4e:hover:active .fui-Icon-regular{display:inline;}",
        ".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}",
        ".f3h1zc4:hover:active{background-color:var(--colorTransparentBackground);}",
        ".f1s2uweq:hover{border-top-color:transparent;}",
        ".fr80ssc:hover{border-right-color:transparent;}",
        ".fecsdlb:hover{border-left-color:transparent;}",
        ".f1ukrpxl:hover{border-bottom-color:transparent;}",
        ".f1h0usnq:hover:active{border-top-color:transparent;}",
        ".fs4ktlq:hover:active{border-right-color:transparent;}",
        ".fx2bmrt:hover:active{border-left-color:transparent;}",
        ".f16h9ulv:hover:active{border-bottom-color:transparent;}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f4lkoma{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1rvyvqg{border-right-color:GrayText;}.f14g86mu{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fjwq6ea:focus{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1lr3nhc:focus{border-right-color:GrayText;}.f1mbxvi6:focus{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fn5gmvv:focus{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1mbxvi6:focus{border-left-color:GrayText;}.f1lr3nhc:focus{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1vmkb5g:hover{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f53ppgq:hover{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1663y11:hover{border-right-color:GrayText;}.f80fkiy:hover{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f18v5270:hover{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f80fkiy:hover{border-left-color:GrayText;}.f1663y11:hover{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1kc2mi9:hover{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1y0svfh:hover:active{background-color:ButtonFace;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fihuait:hover:active{border-top-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fnxhupq:hover:active{border-right-color:GrayText;}.fyd6l6x:hover:active{border-left-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fx507ft:hover:active{border-bottom-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fyd6l6x:hover:active{border-left-color:GrayText;}.fnxhupq:hover:active{border-right-color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fb3rf2x:hover:active{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useRootFocusStyles = /*#__PURE__*/ (0, _react["__styles"])({
    circular: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        kdpuga: [
            "fanj13w",
            "f1gou5sz"
        ],
        Bw81rd7: [
            "f1gou5sz",
            "fanj13w"
        ],
        B6xbmo0: [
            "fulf6x3",
            "foeb2x"
        ],
        dm238s: [
            "foeb2x",
            "fulf6x3"
        ]
    },
    rounded: {},
    square: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        kdpuga: [
            "f1ndz5i7",
            "f1co4qro"
        ],
        Bw81rd7: [
            "f1co4qro",
            "f1ndz5i7"
        ],
        B6xbmo0: [
            "f146y5a9",
            "f1k2ftg"
        ],
        dm238s: [
            "f1k2ftg",
            "f146y5a9"
        ]
    },
    primary: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        B8q5s1w: "f15my96h",
        Bci5o5g: [
            "f8yq1e5",
            "f59w28j"
        ],
        n8qw10: "f1mze7uc",
        Bdrgwmp: [
            "f59w28j",
            "f8yq1e5"
        ],
        j6ew2k: "ftbnf46"
    },
    small: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        kdpuga: [
            "fg3gtdo",
            "fwii5mg"
        ],
        Bw81rd7: [
            "fwii5mg",
            "fg3gtdo"
        ],
        B6xbmo0: [
            "f1palphq",
            "f12nxie7"
        ],
        dm238s: [
            "f12nxie7",
            "f1palphq"
        ]
    },
    medium: {},
    large: {
        Brovlpu: "ftqa4ok",
        B486eqv: "f2hkw1w",
        kdpuga: [
            "ft3lys4",
            "f1la4x2g"
        ],
        Bw81rd7: [
            "f1la4x2g",
            "ft3lys4"
        ],
        B6xbmo0: [
            "f156y0zm",
            "fakimq4"
        ],
        dm238s: [
            "fakimq4",
            "f156y0zm"
        ]
    }
}, {
    f: [
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    i: [
        ".f2hkw1w:focus-visible{outline-style:none;}"
    ],
    d: [
        ".fanj13w[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f1gou5sz[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".fulf6x3[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusCircular);}",
        ".foeb2x[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusCircular);}",
        ".f1ndz5i7[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusNone);}",
        ".f1co4qro[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusNone);}",
        ".f146y5a9[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusNone);}",
        ".f1k2ftg[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusNone);}",
        ".f15my96h[data-fui-focus-visible]{border-top-color:var(--colorNeutralForegroundOnBrand);}",
        ".f8yq1e5[data-fui-focus-visible]{border-right-color:var(--colorNeutralForegroundOnBrand);}",
        ".f59w28j[data-fui-focus-visible]{border-left-color:var(--colorNeutralForegroundOnBrand);}",
        ".f1mze7uc[data-fui-focus-visible]{border-bottom-color:var(--colorNeutralForegroundOnBrand);}",
        ".ftbnf46[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 2px var(--colorStrokeFocus2);}",
        ".fg3gtdo[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusSmall);}",
        ".fwii5mg[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f1palphq[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusSmall);}",
        ".f12nxie7[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusSmall);}",
        ".ft3lys4[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusLarge);}",
        ".f1la4x2g[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusLarge);}",
        ".f156y0zm[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusLarge);}",
        ".fakimq4[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusLarge);}"
    ]
});
const useRootIconOnlyStyles = /*#__PURE__*/ (0, _react["__styles"])({
    small: {
        z8tnut: "f1sl3k7w",
        z189sj: [
            "f136y8j8",
            "f10xn8zz"
        ],
        Byoj8tv: "f1brlhvm",
        uwmqm3: [
            "f10xn8zz",
            "f136y8j8"
        ],
        Bf4jedk: "f17fgpbq",
        B2u0y6b: "f1jt17bm"
    },
    medium: {
        z8tnut: "f1sbtcvk",
        z189sj: [
            "fwiuce9",
            "f15vdbe4"
        ],
        Byoj8tv: "fdghr9",
        uwmqm3: [
            "f15vdbe4",
            "fwiuce9"
        ],
        Bf4jedk: "fwbmr0d",
        B2u0y6b: "f44c6la"
    },
    large: {
        z8tnut: "f1a1bwwz",
        z189sj: [
            "f18k1jr3",
            "f1rtp3s9"
        ],
        Byoj8tv: "fy7v416",
        uwmqm3: [
            "f1rtp3s9",
            "f18k1jr3"
        ],
        Bf4jedk: "f12clzc2",
        B2u0y6b: "fjy1crr"
    }
}, {
    d: [
        ".f1sl3k7w{padding-top:1px;}",
        ".f136y8j8{padding-right:1px;}",
        ".f10xn8zz{padding-left:1px;}",
        ".f1brlhvm{padding-bottom:1px;}",
        ".f17fgpbq{min-width:24px;}",
        ".f1jt17bm{max-width:24px;}",
        ".f1sbtcvk{padding-top:5px;}",
        ".fwiuce9{padding-right:5px;}",
        ".f15vdbe4{padding-left:5px;}",
        ".fdghr9{padding-bottom:5px;}",
        ".fwbmr0d{min-width:32px;}",
        ".f44c6la{max-width:32px;}",
        ".f1a1bwwz{padding-top:7px;}",
        ".f18k1jr3{padding-right:7px;}",
        ".f1rtp3s9{padding-left:7px;}",
        ".fy7v416{padding-bottom:7px;}",
        ".f12clzc2{min-width:40px;}",
        ".fjy1crr{max-width:40px;}"
    ]
});
const useIconStyles = /*#__PURE__*/ (0, _react["__styles"])({
    small: {
        Be2twd7: "fe5j1ua",
        Bqenvij: "fjamq6b",
        a9b677: "f64fuq3",
        Bqrlyyl: "fbaiahx"
    },
    medium: {},
    large: {
        Be2twd7: "f1rt2boy",
        Bqenvij: "frvgh55",
        a9b677: "fq4mcun",
        Bqrlyyl: "f1exjqw5"
    },
    before: {
        t21cq0: [
            "f1nizpg2",
            "f1a695kz"
        ]
    },
    after: {
        Frg6f3: [
            "f1a695kz",
            "f1nizpg2"
        ]
    }
}, {
    d: [
        ".fe5j1ua{font-size:20px;}",
        ".fjamq6b{height:20px;}",
        ".f64fuq3{width:20px;}",
        ".fbaiahx{--fui-Button__icon--spacing:var(--spacingHorizontalXS);}",
        ".f1rt2boy{font-size:24px;}",
        ".frvgh55{height:24px;}",
        ".fq4mcun{width:24px;}",
        ".f1exjqw5{--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}",
        ".f1nizpg2{margin-right:var(--fui-Button__icon--spacing);}",
        ".f1a695kz{margin-left:var(--fui-Button__icon--spacing);}"
    ]
});
const useButtonStyles_unstable = (state)=>{
    const rootBaseClassName = useRootBaseClassName();
    const iconBaseClassName = useIconBaseClassName();
    const rootStyles = useRootStyles();
    const rootDisabledStyles = useRootDisabledStyles();
    const rootFocusStyles = useRootFocusStyles();
    const rootIconOnlyStyles = useRootIconOnlyStyles();
    const iconStyles = useIconStyles();
    const { appearance , disabled , disabledFocusable , icon , iconOnly , iconPosition , shape , size  } = state;
    state.root.className = (0, _react.mergeClasses)(buttonClassNames.root, rootBaseClassName, appearance && rootStyles[appearance], rootStyles[size], icon && size === 'small' && rootStyles.smallWithIcon, icon && size === 'large' && rootStyles.largeWithIcon, rootStyles[shape], // Disabled styles
    (disabled || disabledFocusable) && rootDisabledStyles.base, (disabled || disabledFocusable) && rootDisabledStyles.highContrast, appearance && (disabled || disabledFocusable) && rootDisabledStyles[appearance], // Focus styles
    appearance === 'primary' && rootFocusStyles.primary, rootFocusStyles[size], rootFocusStyles[shape], // Icon-only styles
    iconOnly && rootIconOnlyStyles[size], // User provided class name
    state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(buttonClassNames.icon, iconBaseClassName, state.root.children !== undefined && state.root.children !== null && iconStyles[iconPosition], iconStyles[size], state.icon.className);
    }
    return state;
}; //# sourceMappingURL=useButtonStyles.js.map

//# sourceMappingURL=useButtonStyles.js.map